import { render, staticRenderFns } from "./ContactsTableForLazyLoadingWithResize.vue?vue&type=template&id=d4253a72&scoped=true"
import script from "./ContactsTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"
export * from "./ContactsTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4253a72",
  null
  
)

export default component.exports